module.exports = __webpack_public_path__ + "img/arrow_forward.6e7d2a76.svg";